import { memo } from 'react';
import { Typography, IconButton, Avatar } from '@mui/material';
import { ContentCopy, Delete, SettingsEthernet } from '@mui/icons-material';

import { ActionsContainer, ListItemButtonStyled } from '../styles';
import { IRowProps } from '../types';

/**
 * @template T - The type of the value in the item object ISearchEntity<T=value>.
 */

export const RowComponent = <T,>({
  index,
  currentItem,
  selectedItem,
  action,
  height,
  showAvatar,
  readonly,

  error,
  onItemClick,
  onItemCopy,
  onItemDelete,
}: IRowProps<T>) => {
  const hasFullTextSpace = showAvatar === undefined && action === false;

  return (
    <ListItemButtonStyled
      onClick={() => onItemClick(currentItem, index)}
      sx={{ height }}
      selected={selectedItem}
      disableRipple
      $hasFullTextSpace={hasFullTextSpace}
    >
      {showAvatar && (
        <>
          {!currentItem.icon ? (
            <SettingsEthernet />
          ) : (
            <Avatar src={currentItem.icon} variant='square' alt={currentItem.label} sx={{ width: 24, height: 24 }} />
          )}
        </>
      )}
      <Typography variant='inherit' noWrap>
        {currentItem.label}
      </Typography>
      {Boolean(action) && (
        <ActionsContainer>
          {onItemCopy !== undefined && (
            <IconButton size='small' disabled={readonly} onClick={(e) => onItemCopy(e, currentItem.value)}>
              <ContentCopy fontSize='small' />
            </IconButton>
          )}

          {onItemDelete && (
            <IconButton
              disabled={readonly}
              size='small'
              onClick={(e) => onItemDelete(e, currentItem.value as T)}
              hidden={onItemDelete === undefined}
            >
              <Delete fontSize='small' />
            </IconButton>
          )}
        </ActionsContainer>
      )}
      {error?.(index)}
    </ListItemButtonStyled>
  );
};
export const Row = memo(RowComponent) as <T>(props: IRowProps<T>) => React.JSX.Element | null;
